import React, { Component } from 'react'
import { List } from 'immutable'
import { IOnboardingLandingProps } from './interface'
import SingleProTrackLevel from './SingleProTrackLevel/SingleProTrackLevel'
import MultipleProTrackLevels from './MultipleProTrackLevels/MultipleProTrackLevels'
import Divider from 'app/components/Divider/Divider'
import './styles.scss'

export const bc = 'on-boarding-landing'

class OnboardingLanding extends Component<IOnboardingLandingProps> {
  static defaultProps = {
    fullNameOrEmail: 'Someone',
    text: 'The ProHabits program is reserved for culture leaders inspiring change inside transforming organizations.',
    description:
      'Daily reminders to bring the best version of yourself to life. If you commit in the morning, another message arrives later to ask if you did it.',
    quoteImage: 'https://assets.prohabits.com/prohabits/welcome.jpg',
    proTrackLevels: List(),
  }

  render() {
    const {
      t,
      fullNameOrEmail,
      text,
      proTrackLevels,
      quoteImage,
      setQueriesAndGoToDashboard,
      isTextIncludeHtmlTags,
    } = this.props
    const areProTrackLevelsExisting = proTrackLevels.size > 0

    return (
      <div className={bc}>
        <div className={`${bc}__greeting`}>
          <div className={`${bc}__greeting-image`} style={{ backgroundImage: `url(${quoteImage})` }} />

          <div className={`${bc}__greeting-text`}>
            <div className={`${bc}__greeting-title`}>Welcome {fullNameOrEmail},</div>
            <div className={`${bc}__greeting-subtitle`}>
              {isTextIncludeHtmlTags ? <span dangerouslySetInnerHTML={{ __html: text }} /> : <span>{t(text)}</span>}
            </div>
          </div>

          <Divider />
          <div className={`${bc}__do-you-commit`}>
            {areProTrackLevelsExisting
              ? t('Do you commit?')
              : t('Please contact Happy@ProHabits.com to request access')}
          </div>
          <Divider />

          {areProTrackLevelsExisting &&
            (proTrackLevels.size === 1 ? (
              <SingleProTrackLevel
                setQueriesAndGoToDashboard={setQueriesAndGoToDashboard}
                proTrackLevel={proTrackLevels.first()}
              />
            ) : (
              <MultipleProTrackLevels
                setQueriesAndGoToDashboard={setQueriesAndGoToDashboard}
                proTrackLevels={proTrackLevels}
              />
            ))}
          <div className={`${bc}__sign`}>{t('“We are what we repeatedly do”')}</div>
        </div>
      </div>
    )
  }
}

export default OnboardingLanding
